/**
 * Date formatters mirroring the legacy `utils/dateUtils.js` contract.
 * Customer-supplied `timeFormat` / `dateTimeFormat` strings (e.g.
 * "shortTime", "isoDateTime") map to `Intl.DateTimeFormat` option
 * presets. We keep the same key set so old admin-side configurations
 * keep rendering identical strings without a migration.
 */
const DAY_MS = 60 * 60 * 24 * 1000

const PRESETS = {
  default: {
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  },
  shortDate: { month: 'numeric', day: 'numeric', year: '2-digit' },
  paddedShortDate: { month: '2-digit', day: '2-digit', year: 'numeric' },
  mediumDate: { month: 'short', day: 'numeric', year: 'numeric' },
  longDate: { month: 'long', day: 'numeric', year: 'numeric' },
  fullDate: {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  },
  shortTime: { hour: 'numeric', minute: '2-digit', hour12: true },
  mediumTime: {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  },
  longTime: {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  },
  isoDate: { year: 'numeric', month: '2-digit', day: '2-digit' },
  isoTime: {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  },
  isoDateTime: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  },
}

export function formatDate(date, format) {
  const opts = PRESETS[format] || PRESETS.default
  let formatted = new Intl.DateTimeFormat('en-US', opts).format(date)
  if (format === 'isoDate') formatted = formatted.replace(/\//g, '-')
  else if (format === 'isoDateTime')
    formatted = formatted.replace(/\//g, '-').replace(',', 'T')
  return formatted
}

export function isMessageFromToday(date) {
  return Date.now() - date.getTime() < DAY_MS
}

export function getMessageTime(date, timeFormat, dateTimeFormat) {
  return isMessageFromToday(date)
    ? formatDate(date, timeFormat)
    : formatDate(date, dateTimeFormat)
}
